/**
 * Deep merge 2 objects
 *
 * @param {object} target Initial object
 * @param {object} source Object to merge with target
 * @returns {object} Deep merged object
 */
export const mergeObjects = (target, source) => {
  const mergedObject = { ...target }

  for (const key in source) {
    if (key in source) {
      if (typeof mergedObject[key] === 'object' && typeof source[key] === 'object') {
        mergedObject[key] = mergeObjects(mergedObject[key], source[key])
        continue
      }
      mergedObject[key] = source[key]
    }
  }

  return mergedObject
}

/**
 * Copy text to clipboard.
 * Returns a Promise that resolves on success and rejects with an Error on failure
 * The caller (component) should handle showing alerts or other UI
 *
 * Example:
 * copyToClipboard(text)
 *   .then(() => this.$eventBus.$emit('show-alert', { title: this.$t('Company.CopiedInClipboard') }))
 *   .catch(() => this.$eventBus.$emit('show-alert', { title: this.$t('Company.CopiedInClipboardError') }));
 */
export const copyToClipboard = (text) => {
  return new Promise((resolve, reject) => {
    if (typeof text === 'undefined' || text === null) {
      return;
    }

    if (!navigator.clipboard) {
      fallbackCopyValue(text).then(resolve).catch(reject);
      return;
    }

    navigator.clipboard.writeText(String(text)).then(resolve).catch(reject);
  });
};

const fallbackCopyValue = (text) =>  {
  return new Promise((resolve, reject) => {
    var textArea = document.createElement("textarea");
    textArea.value = String(text);
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      if (successful) {
        resolve();
      } else {
        reject(new Error('Fallback: copy command was unsuccessful'));
      }
    } catch (err) {
      document.body.removeChild(textArea);
      reject(err);
    }
  });
};
